/*
   Let webpack know we are using those css files.
   ExtractTextPlugin will use those lines to know what to pull out to external css.
 */
import '../stylesheets/app.scss';

import './services/initializeErrorReporting';

// 3rd party scripts
import FastClick from 'fastclick';

import 'promise-polyfill/dist/polyfill';

// Import modules
import AvailabilityOvernight from './AvailabilityOvernight';
import GoogleMapSearchResult from './GoogleMapSearchResult';
import AdvancedFilterPresets from './AdvancedFilterPresets';
import AttachmentInput from './AttachmentInput';
import AvailabilityCalendar from './DetailView/AvailabilityCalendar';
import CharacterLimiter from './CharacterLimiter';
import CheckboxDependent from './CheckboxDependent';
import CheckoutPaymentForm from './CheckoutPaymentForm';
import Datepicker from './Datepicker';
import FlashMessages from './FlashMessages';
import Galleries from './DetailView/Galleries';
import initGeolocationForms from './Geolocation/Geolocation';
import Hints from './Hints';
import HomeAddressSameAsService from './HomeAddressSameAsService';
import InterceptButtons from './InterceptButtons';
import MainNavigation from './MainNavigation';
import MaskedInputs from './MaskedInputs';
import OrderActionsFactory from './OrderActionsFactory';
import PartnersCarousel from './PartnersCarousel';
import PriceInput from './PriceInput';
import ProfileTestimonialsCarousel from './DetailView/TestimonialsCarousel';
import SearchSortTrigger from './SearchSortTrigger';
import SelectDependent from './SelectDependent';
import Selects from './Selects';
import Slideshow from './Slideshow';
import MultipleAddresses from './MultipleAddresses';
import AddressController from './legacy/address_controller';

// import TestimonialsCarousel from './TestimonialsCarousel';
import Timepicker from './Timepicker';
import TogglableCategories from './TogglableCategories';
import Toggles from './Toggles';
import Tooltips from './Tooltips';
import TruncateList from './TruncateList/TruncateList';
import UnsavedFormWarning from './UnsavedFormWarning';
import UserMessagesInitializer from './UserMessagesInitializer';
import FormErrorShower from './FormErrorShower';
import PoliceCheckRenevalDate from './PoliceCheckRenevalDate';
import Lightbox from './Lightbox';
import CompleteTimesheet from './CompleteTimesheet';
import DateInputInitializer from './DateInputInitializer';
import CheckoutController from './CheckoutController';

import myOrdersInitializer from './MyOrders/initializer';
import ComboTab from './ComboTab';
import liquidErrorsReporter from './services/liquidErrorsReporter';

import UpdateEndTime from './UpdateEndTime';

// Initialize modules
$(() => {
  new AvailabilityOvernight();
  new GoogleMapSearchResult();
  new AdvancedFilterPresets();
  new AttachmentInput();
  new AvailabilityCalendar();
  new CharacterLimiter();
  new CheckboxDependent();
  new CheckoutPaymentForm();
  new Datepicker();
  new FlashMessages();
  new Galleries();
  initGeolocationForms();
  new Hints();
  new HomeAddressSameAsService();
  new InterceptButtons();
  new MainNavigation();
  new MaskedInputs();
  new OrderActionsFactory();
  new PartnersCarousel();
  new PriceInput();
  new ProfileTestimonialsCarousel();
  new SearchSortTrigger();
  new SelectDependent();
  new Selects();
  new Slideshow();
  new TogglableCategories();
  new Toggles();
  new Tooltips();
  new TruncateList();
  new UnsavedFormWarning();
  new UserMessagesInitializer();
  new FormErrorShower();
  new PoliceCheckRenevalDate();
  new Lightbox();
  new CompleteTimesheet();
  new ComboTab();
  new AddressController();
  new MultipleAddresses();
  new DateInputInitializer();
  new CheckoutController();
  new Timepicker();
  new UpdateEndTime();
  myOrdersInitializer();
  liquidErrorsReporter();
});

// Initialize fastclick - remove 300ms delay on touch-enabled devices
$(() => {
  /*
    iPad/Safari had issues with this script on features:
      Label interceptors (or checkboxes in general)
      Google Autocomplete address selection
      Event was not passed down to event handlers for some reason
  */
  const isApple = navigator.userAgent.match(/(iPad|iPhone|iPod)/g);

  if (!isApple || isApple.length === 0) {
    FastClick.attach(document.body);
  }
});



// WEBPACK FOOTER //
// ./src/javascripts/index.js